var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15.0488V20.0488H10.5V15.0488H13.5ZM12 4C13.1097 4 14.0412 4.79858 15.9043 6.39551L16.9043 7.25293C17.9351 8.13648 18.4511 8.57814 18.7256 9.1748C19 9.77154 19 10.4508 19 11.8086V16.0488C19 17.9344 18.9998 18.8771 18.4141 19.4629C17.8825 19.9944 17.0571 20.0404 15.5 20.0449V15.0488C15.5 13.9443 14.6046 13.0488 13.5 13.0488H10.5C9.39543 13.0488 8.5 13.9443 8.5 15.0488V20.0449C6.94288 20.0404 6.11748 19.9944 5.58594 19.4629C5.00016 18.8771 5 17.9344 5 16.0488V11.8086C5 10.4508 4.99995 9.77154 5.27441 9.1748C5.54889 8.57814 6.0649 8.13648 7.0957 7.25293L8.0957 6.39551C9.95879 4.79858 10.8903 4 12 4Z",
    fill: "#202232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/DashboardActive.2d2742c973ff8fefeae7250263b48cd0.svg";
export { ForwardRef as ReactComponent };